import React, { ReactElement, ReactNode } from 'react';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import {
  EPageContext,
  fontMontserrat,
  fontColorLink,
  fontColorLinkHover,
  fontColorLinkActive
} from '@rambler-help/shared';

import { useRootStore } from '@stores/index';

import BackIcon from './images/back.svg?module';

const BackContainer = styled.div<{ context?: EPageContext }>`
  position: relative;
  margin-bottom: ${({ context = EPageContext.User }) => (
    context === EPageContext.Admin ? '10px' : '30px'
  )};

`;
const backIconStyle = css`
  position: absolute;
  top: 0;
  left: 0;
`;
const Link = styled.a`
  display: inline-block;
  padding: 0 0 0 25px;
  text-decoration: none;
  ${fontMontserrat}
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  ${fontColorLink}
  &:hover {
    ${fontColorLinkHover}
  }
  &:active {
    ${fontColorLinkActive}
  }
`;

interface BackComponentProps {
  to: string;
  children?: ReactNode;
}

export const Back = ({ to, children }: BackComponentProps): ReactElement => {
  const { layout } = useRootStore();

  return (
    <BackContainer context={layout.pageContext}>
      <Link href={to}>
        <BackIcon className={backIconStyle} />
        {children}
      </Link>
    </BackContainer>
  );
};

